
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { useTeamsList } from './useTeamsList';
import { useTeamCreate } from './useTeamCreate';
import { useTeamUpdate } from './useTeamUpdate';
import { useTeamDelete } from './useTeamDelete';
import { Team } from '../types';

export type { Team } from '../types';

export function useTeams() {
  const { user, isLoading } = useAuth();
  const queryClient = useQueryClient();

  const teamsQuery = useTeamsList();
  const createTeam = useTeamCreate();
  const updateTeam = useTeamUpdate();
  const deleteTeam = useTeamDelete();

  return {
    teams: teamsQuery.data || [],
    isLoading: isLoading || teamsQuery.isLoading,
    error: teamsQuery.error,
    createTeam,
    updateTeam,
    deleteTeam,
  };
}
